<template>
  <div class="rich-editor">
    <div ref="editor" class="rich-editor__container"></div>
  </div>
</template>

<script>
import E from 'wangeditor'
import { uploadImage } from '../../../api/common'
import { API_BASE_URL } from '../../../config'

export default {
  name: 'RichEditor',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '请输入内容...' }
  },
  data() {
    return {
      editor: null
    }
  },
  mounted() {
    this.initEditor()
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  watch: {
    value(val) {
      if (this.editor && this.editor.txt.html() !== val) {
        this.editor.txt.html(val || '')
      }
    }
  },
  methods: {
    initEditor() {
      this.editor = new E(this.$refs.editor)
      this.editor.config.placeholder = this.placeholder
      this.editor.config.height = 300
      this.editor.config.zIndex = 1
      this.editor.config.showFullScreen = false
      this.editor.config.menus = [
        'head',
        'bold',
        'fontSize',
        'italic',
        'underline',
        'strikeThrough',
        'foreColor',
        'backColor',
        'link',
        'list',
        'justify',
        'quote',
        'image',
        'table',
        'splitLine',
        'undo',
        'redo'
      ]
      // 图片上传配置：隐藏 base64，使用服务器上传
      this.editor.config.uploadImgShowBase64 = false
      this.editor.config.uploadImgServer = ''
      this.editor.config.customUploadImg = async (resultFiles, insertImgFn) => {
        try {
          const file = resultFiles[0]
          if (!file) return
          const res = await uploadImage(file)
          const data = res.data
          let url = ''
          if (typeof data === 'string') {
            url = data
          } else if (data && typeof data === 'object') {
            url = data.url || data.fileUrl || data.filePath || data.path || data.src || ''
          }
          if (url && !/^https?:\/\//.test(url)) {
            url = API_BASE_URL + url
          }
          if (url) {
            insertImgFn(url)
          } else {
            console.error('图片上传成功但未找到URL字段，返回数据:', res)
          }
        } catch (err) {
          console.error('图片上传失败:', err)
        }
      }
      this.editor.config.onchange = (html) => {
        this.$emit('change', html)
      }
      this.editor.create()
      if (this.value) {
        this.editor.txt.html(this.value)
      }
    }
  }
}
</script>

<style scoped>
.rich-editor {
  width: 100%;
}

.rich-editor__container {
  border: 1px solid #ebedf0;
  border-radius: 4px;
  overflow: hidden;
}

.rich-editor__container >>> .w-e-toolbar {
  flex-wrap: wrap;
  border: none;
  border-bottom: 1px solid #ebedf0;
  background: #fafafa;
}

.rich-editor__container >>> .w-e-text-container {
  border: none !important;
  height: 300px !important;
}

.rich-editor__container >>> .w-e-text {
  padding: 12px;
  font-size: 15px;
  line-height: 1.8;
}
</style>
